import React from "react";
import Select from "react-select";
import { Button } from "@wac-ui-dashboard/wac_component_library";

const MediaShortsFilterForm = ({
  formik,
  handleReset,
  categoryList,
  rjList, 
}) => {
  let statusList = [
    {
      id: "0",
      label: "Inactive",
    },
    { id: "1", label: "Active" },
  ];

  const today = new Date();
  today.setDate(today.getDate() - 1); 
  const minDate = today.toISOString().split('T')[0];

  return (
    <div>
  
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Status
        </label>
        <Select
          id="status"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          name="status"
          options={statusList}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.label}
          value={statusList?.filter((m) => formik.values.status === m.id)}
          onChange={(value) => formik.setFieldValue("status", value?.id)}
        />
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Category
        </label>
        <Select
          id="category_id"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          isMulti
          name="category_id"
          options={categoryList}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) => option?.name}
          value={categoryList?.filter((m) =>
            formik.values.category_id?.includes?.(m._id)
          )}
          onChange={(value) =>
            formik.setFieldValue(
              "category_id",
              value.map((v) => v._id)
            )
          }
        />
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Rj
        </label>
        <Select
          id="rj_id"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          isMulti
          name="rj_id"
          options={rjList}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) => option?.name}
          value={rjList?.filter((m) => formik.values.rj_id?.includes?.(m._id))}
          onChange={(value) =>
            formik.setFieldValue(
              "rj_id",
              value.map((v) => v._id)
            )
          }
        />
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          From date
        </label>
        <input
          className={`pro-input lg`}
          type="date"
          name="from_date"
          max={minDate}
          onChange={formik.handleChange}
          value={formik.values.from_date}
        />
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          To date
        </label>
        <input
          className={`pro-input lg`}
          type="date"
          name="to_date"
          max={new Date().toISOString().split("T")[0]}
          onChange={formik.handleChange}
          value={formik.values.to_date}
        />
      </div>

      <div
        className={`col-12 pro-d-flex pro-justify-end ${"offcanvas-footer-sticky-btn"}`}
      >
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleReset}>
          Reset
        </Button>

        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default MediaShortsFilterForm;
